export default "/imgs/letter-1.png"